import moment from "moment"

const parseDate = (str, format) => {
  if (str) {
    return moment(str).format(format)
  }
}

export default parseDate
